const addTrackingUrchinsToUrl = (shareUrl, utmSource) => {
  const delimiter = shareUrl.match(/\?/) ? "&" : "?";
  return `${shareUrl}${delimiter}utm_source=${utmSource}&utm_campaign=share&utm_medium=web`;
};

export default addTrackingUrchinsToUrl;
